import * as React from 'react';

export function ImageIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<rect width='18' height='18' x='3' y='3' rx='2' ry='2' />
			<circle cx='9' cy='9' r='2' />
			<path d='m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21' />
		</svg>
	);
}
